import type { HardBreak, InlineNode } from '../types';

export const isHardBreakNode = (node: InlineNode): node is HardBreak => {
  return 'type' in node && node.type === 'hardBreak';
};
